/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';
import * as actions from '../action';
import * as c from '../constant';

function FeesTaggingContainer({
  getFeeCodes,
  feeCodesList,
  getFeeSettings,
  feeSettings,
  updateFeeSettings,
  ordinanceRevisionId
}) {
  {
    /* Discount and Penalty Settings: */
  }
  const [codeFeesListFormat, setCodeFeesListFormat] = useState([]); // description
  const [codeSettingListFormat, setCodeSettingListFormat] = useState([]); // discount & penalty
  const [mode, setMode] = useState(0);
  const [formData, setFormData] = useState([]);
  const [feeCodes, setFeeCodes] = useState({
    DISCOUNT: {
      fee_codes: [],
      type: 'DISCOUNT',
    },
    INTEREST: {
      fee_codes: [],
      type: 'INTEREST',
    },
    SURCHARGE: {
      fee_codes: [],
      type: 'SURCHARGE',
    },
  });

  const getValidFeeCodes = () => {
    const fees = _.get(feeCodesList, 'fees', []);
    return fees.map((fee) => String(_.get(fee, 'code', '')));
  };

  const sanitizeTagSelections = (list) => {
    const validFeeCodes = getValidFeeCodes();

    if (_.isEmpty(validFeeCodes)) return list;

    return (list || []).filter((item) =>
      _.includes(validFeeCodes, String(_.get(item, 'fee_code', '')))
    );
  };

  const sanitizeFeeSettingsPayload = (settings) => {
    const validFeeCodes = getValidFeeCodes();

    if (_.isEmpty(validFeeCodes)) return settings;

    return settings.map((item) => ({
      ...item,
      fee_codes: _.uniq(
        (_.get(item, 'fee_codes') || []).filter((code) =>
          _.includes(validFeeCodes, String(code))
        )
      ).sort(),
    }));
  };

  const formatFormData = () => {
    if (!_.isEmpty(feeSettings)) {
      const list = feeSettings.map((item) => {
        return {
          // id: item.id,
          // fee_code_list: [_.get(item, "attributes.fee_code")],
          type: _.get(item, 'attributes.type'),
          fee_code: _.get(item, 'attributes.fee_code'),
        };
      });
      const sanitizedList = sanitizeTagSelections(list);

      setCodeSettingListFormat(sanitizedList);
      setFormData(sanitizedList);
    }
  };

  useEffect(() => {
    getFeeCodes({
      ordinance_revision_id: ordinanceRevisionId,
    });
    getFeeSettings();
  }, []);

  useEffect(() => {
    formatFormData();
  }, [feeSettings]);

  useEffect(() => {
    if (!_.isEmpty(_.get(feeCodesList, 'fees'))) {
      setCodeFeesListFormat(_.get(feeCodesList, 'fees'));
    }
  }, [_.get(feeCodesList, 'fees'), formData]);

  useEffect(() => {
    if (_.isEmpty(formData)) return;

    const sanitizedFormData = sanitizeTagSelections(formData);
    if (sanitizedFormData.length === formData.length) return;

    setFormData(sanitizedFormData);
    setCodeSettingListFormat(sanitizeTagSelections(codeSettingListFormat));
  }, [_.get(feeCodesList, 'fees')]);

  // retrieve initial data and map into array of FEE_CODES (for onSubmit)
  const formatFeeCodes = () => {
    const filterFeeType = (type) => {
      let arrItem = [];

      formData
        .filter((item) => `${item.type}` === type)
        .map((data) => arrItem.push(`${data.fee_code}`));

      return setFeeCodes((prevFeeCodes) => {
        return {
          ...prevFeeCodes,
          [type]: {
            ...prevFeeCodes[type],
            fee_codes: [...arrItem].sort(),
          },
        };
      });
    };

    filterFeeType('SURCHARGE');
    filterFeeType('INTEREST');
    filterFeeType('DISCOUNT');
  };

  useEffect(() => {
    formatFeeCodes();
  }, [formData]);

  // TEMPORARY FIX FOR MINOR BUG
  const handleSetMode = (num) => {
    setMode(num);
  };

  const renderCheckbox = (code, type) => {
    const item =
      formData.filter((data) => data.fee_code === code && data.type === type) ||
      {};

    return (
      <button
        type="button"
        className="btn-blank"
        onClick={handleToggle(code, type)}
      >
        {_.isEmpty(item) ? (
          <i className="far fa-square icon-check-box" />
        ) : (
          <i className="fas fa-check-square icon-box" />
        )}
      </button>
    );
  };

  const handleToggle = (code, type) => () => {
    handleSetMode(1);
    const item =
      formData.find((data) => data.fee_code == code && data.type == type) || {};

    if (_.isEmpty(item)) {
      setFormData(
        _.concat(formData, {
          type,
          fee_code: code,
        })
      );
      setFeeCodes((prevFeeCodes) => {
        return {
          ...prevFeeCodes,
          [type]: {
            fee_codes: [..._.get(prevFeeCodes, `${type}.fee_codes`), code],
            type,
          },
        };
      });

      return true;
    }

    if (!_.isEmpty(item)) {
      setFormData(_.reject(formData, item));
      setFeeCodes((prevFeeCodes) => {
        const newItem = _.get(prevFeeCodes, `${type}.fee_codes`)
          .filter((item) => item !== code)
          .sort();

        return {
          ...prevFeeCodes,
          [type]: {
            fee_codes: [...newItem],
            type,
          },
        };
      });
      return true;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSetMode(0);
    const args = {
      fee_settings: sanitizeFeeSettingsPayload([...Object.values(feeCodes)]),
    };
    updateFeeSettings(args);
  };

  const handleCancel = () => {
    setFormData(codeSettingListFormat);
    handleSetMode(0);
  };

  // filter unique items(type) in an array of object
  // const filterDuplicateCodeSettingsList = [...new Map(codeSettingListFormat.map((item) => [item["type"], item])).values()].sort();

  return (
    <div className="card-content-listing">
      <div className="container-fluid p-0">
        <div className="row">
          <div className="col-6">
            <h3>Fees Tagging</h3>
          </div>
          {/* listing */}
          <div className="col-6 d-flex">
            {mode === 1 ? (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold ml-auto px-4 mr-1"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-secondary btn-round font-weight-bold px-4"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </React.Fragment>
            ) : (
              ''
            )}
          </div>
        </div>
        {/* TABLE */}
        <div
          className="table-responsive mt-4"
          style={{
            maxHeight: '60vh',
            overflowY: 'auto',
            overflowX: 'auto',
            border: '1px solid #e9ecef',
            borderRadius: '12px',
            backgroundColor: '#fff',
          }}
        >
          <table className="table table-striped table-borderless mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="px-2 py-3"
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#fff',
                    textTransform: 'uppercase',
                    fontSize: '12px',
                  }}
                >
                  Fees Description
                </th>
                <th
                  scope="col"
                  className="px-2 py-3"
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#fff',
                    textTransform: 'uppercase',
                    fontSize: '12px',
                  }}
                >
                  <div className="w-100 text-center">DISCOUNT</div>
                </th>
                <th
                  scope="col"
                  className="px-2 py-3"
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#fff',
                    textTransform: 'uppercase',
                    fontSize: '12px',
                  }}
                >
                  <div className="w-100 text-center">INTEREST</div>
                </th>
                <th
                  scope="col"
                  className="px-2 py-3"
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#fff',
                    textTransform: 'uppercase',
                    fontSize: '12px',
                  }}
                >
                  <div className="w-100 text-center">SURCHARGE</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {!_.isEmpty(codeFeesListFormat) ? (
                <>
                  {codeFeesListFormat.map((item) => {
                    return (
                      <React.Fragment key={_.get(item, 'code') || uuid()}>
                        <tr className="top-border">
                          <td className="font-weight-bold py-3">
                            {_.get(item, 'code')} -{' '}
                            {_.get(item, 'description')}
                          </td>
                          <td className="py-3">
                            <div className="w-100 text-center">
                              {renderCheckbox(item.code, 'DISCOUNT')}
                            </div>
                          </td>
                          <td className="py-3">
                            <div className="w-100 text-center">
                              {renderCheckbox(item.code, 'INTEREST')}
                            </div>
                          </td>
                          <td className="py-3">
                            <div className="w-100 text-center">
                              {renderCheckbox(item.code, 'SURCHARGE')}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </>
              ) : (
                <tr />
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

FeesTaggingContainer.propTypes = {
  getFeeCodes: PropTypes.instanceOf(Function).isRequired,
  feeCodesList: PropTypes.instanceOf(Object).isRequired,

  getFeeSettings: PropTypes.instanceOf(Function).isRequired,
  feeSettings: PropTypes.instanceOf(Object).isRequired,
  updateFeeSettings: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  feeCodesList: _.get(api, `${c.GET_FEE_CODES}.res`) || [],
  feeSettings: _.get(api, `${c.GET_FEE_SETTINGS}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FeesTaggingContainer);
